// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "airplane__name-3SqFH";
var _4 = "details-2aKmc";
var _5 = "sunInfo-a3aQ_";
var _6 = "amenities__item-3JoGq";
var _7 = "airplane__amenities-1MIOR";
var _8 = "airplane-3UYWS";
var _9 = "seatsDetails-FrBji";
var _a = "seatsDetails_icon-2dWUs";
export { _1 as "__esModule", _2 as "mobile", _3 as "airplane__name", _4 as "details", _5 as "sunInfo", _6 as "amenities__item", _7 as "airplane__amenities", _8 as "airplane", _9 as "seatsDetails", _a as "seatsDetails_icon" }
export default { "__esModule": _1, "mobile": _2, "airplane__name": _3, "details": _4, "sunInfo": _5, "amenities__item": _6, "airplane__amenities": _7, "airplane": _8, "seatsDetails": _9, "seatsDetails_icon": _a }
